/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 16.08.2016.
 */

import {ShowToast} from '../common/actions-common';

export const FETCH_ALL_RECORDS  = 'fetch-all-records-from-npvr';
export const ADD_TO_SCHEDULE  = 'add-event-to-schedule';
export const REMOVE_FROM_SCHEDULE  = 'remove-event-from-schedule';

export function AddEventToSchedule(epgEventId, deviceId) {

  // Invert control!
  // Return a function that accepts `dispatch` so we can dispatch later.
  // Thunk middleware knows how to turn thunk async actions into actions.

  return function (dispatch) {
    return lh.rdvr.addRecordingScheduleItem(epgEventId, deviceId).then(
      response => dispatch({
        type: ADD_TO_SCHEDULE,
        payload: response
      }),
      reason => dispatch(ShowToast({
        type: 'record',
        message: reason.message,
        operation: 'record_add_fail',
        isError: true
      }))
    );
  };
}

export function GetAllRecords() {

  return {
    type: FETCH_ALL_RECORDS,
    payload: lh.rdvr.getRecords()
  }
}

export function CancelRecoding(recordId) {

  return {
    type: REMOVE_FROM_SCHEDULE,
    payload: lh.rdvr.removeRecordingScheduleItem(recordId)
  }
}



// WEBPACK FOOTER //
// ./src/actions/npvr/action-npvr.js